import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";


import "./App.css";
// 
import {Layout} from  './components'
//
import {
  AboutStore,
  TypeOfStroke,
  SignsAndSymptons,
  StokeTreatment,
  TIATreatment,
  IvTpaChecklist,
  StrokePrevention,
} from './pages'

import {
  NotFound
} from './erros'

function App() {
  return (
    <Router>
      <Layout>
        <Switch>
          <Route exact path="/" component={AboutStore}/>
          <Route exact path="/sign-and-symptoms" component={SignsAndSymptons}/>
          <Route exact path="/stroke-type" component={TypeOfStroke}/>
          <Route exact path="/stroke-treatment" component={StokeTreatment}/>
          <Route exact path="/tia-treatment" component={TIATreatment}/>
          <Route exact path="/iv-tpa-checklist" component={IvTpaChecklist}/>
          <Route exact path="/stroke-prevention" component={StrokePrevention}/>
          <Route component={NotFound}/>
        </Switch>
      </Layout>
    </Router>
  );
}

export default App;
